// import rightImg from "images/hero-right1.png";
import rightImg from "images/about/Maps.png";
import React, { FC } from "react";
import SectionFounder, { People } from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionPromo3 from "components/SectionPromo3";
import NcImage from "shared/NcImage/NcImage";

export interface PageAboutProps {
    className?: string;
}

const FOUNDER_DEMO: People[] = [
    {
        id: "1",
        name: `Niamh O'Shea`,
        job: "Co-founder and Chief Executive",
        avatar:
            "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
    },
    {
        id: "4",
        name: `Danien Jame`,
        job: "Co-founder and Chief Executive",
        avatar:
            "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
    },
    {
        id: "3",
        name: `Orla Dwyer`,
        job: "Co-founder, Chairman",
        avatar:
            "https://images.unsplash.com/photo-1560365163-3e8d64e762ef?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
    },
    {
        id: "2",
        name: `Dara Frazier`,
        job: "Co-Founder, Chief Strategy Officer",
        avatar:
            "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80",
    },
];


const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
    return (
        <div
            className={`nc-PageAbout overflow-hidden relative ${className}`}
            data-nc-id="PageAbout"
        >
            <Helmet>
                <title>About || Mangalya.lk</title>
            </Helmet>

            {/* ======== BG GLASS ======== */}
            {/* <BgGlassmorphism /> */}

            <div className="w-full h-[140px] md:h-[145px] xl:h-[155px] 2xl:h-[175px] bg-cover bg-center bg-[#F4F4F4] relative z-[1]"
            // style={{
            //   backgroundImage: `url(${cover})`
            // }}
            >
                <div className="w-full h-full flex justify-center items-center px-4">
                    <div className="" >
                        <h2 className="nc-SectionHero2Item__heading font-semibold text-xl xl:text-xl 2xl:text-3xl !leading-[114%]  flex justify-center font-black text-center">
                            About Us

                        </h2>
                        <span className="nc-SectionHero2Item__subheading block text-sm md:text-sm  font-medium flex justify-center mt-2 max-w-3xl text-center px-3 lg:px-0">
                            {/* Start Shopping */}
                        </span>
                        {/* <div className="w-full flex items-center justify-center">
              <button
                className={
                  `ttnc-ButtonCircle rounded-full flex items-center justify-center !leading-none disabled:bg-opacity-70 
        w-3xl px-6 h-9 font-medium mt-2 cursor-pointer hover:bg-slate-800 w-2xl bg-white text-slate-900 hover:text-slate-50 mt-4`}



              >

                <span className="block  text-xs font-medium">
                  Create Page
                </span>

              </button>

            </div> */}


                    </div>

                </div>



            </div>

            <div className="container py-16 lg:py-14 space-y-16 lg:space-y-6">
                {/* <SectionHero
          rightImg={rightImg}
          heading="👋 About Us."
          btnText=""
          subHeading="We’re impartial and independent, and every day we create distinctive, world-class programmes and content which inform, educate and entertain millions of people in the around the world."
        /> */}

                <div className="flex items-center justify-items-center justify-center grid grid-cols-1 lg:grid-cols-1 gap-10 ">

                    <div className="">

                        <h2 className="text-xl font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100">
                            What is Tidytraderr, and how does it benefit cleaning businesses
                            (wholesalers and retailers), cleaning service providers, service
                            seekers, and job seekers?
                        </h2>
                        <div className="text-left">
                            {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-6">
                                Refunds
                            </h2> */}
                            <span className="block text-sm xl:text-sm text-neutral-6000 dark:text-neutral-400 mt-3">
                                Tidytraderr is the latest and rapidly expanding marketplace within the
                                cleaning industry in Australia. It serves as an all-encompassing
                                platform that connects various stakeholders of the cleaning industry,
                                including retailers, wholesalers, service providers, service seekers,
                                and job seekers. Join us today to personally experience the numerous
                                benefits it offers.</span>
                            {/* <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3">
                                If a member wishes to deactivate or delete their account, they can do so at any time. However, please note that if a member is in the middle of a paid subscription, they will not be entitled to any refunds. This is because we provide our members with access to our services as soon as payment is made, and we cannot recover the costs associated with that access once it has been granted.                            </span>
                            <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3">
                                To deactivate or delete an account, simply log in to your account and follow the instructions provided on the website. If you encounter any difficulties, please do not hesitate to contact our support team (support@infinitycs.com.au) for assistance.                            </span>


                            <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3">
                                We hope that you will be satisfied with our service and that you will continue to use Tidytraderr for your cleaning needs. If you have any questions or concerns about our profile cancellation policy, please feel free to contact us.
                            </span> */}
                            {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-8">
                                Faulty or Damaged Goods Under Warranties
                            </h2>
                            <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3">
                                In addition to specific guarantees from manufacturers, Oz Cleaning Suppplies and its suppliers provide a guarantee of acceptable quality on every product by law. You’re entitled to a replacement or refund for a major failure. You may also be compensated for other reasonably foreseeable loss or damage. You are also entitled to have the goods replaced or repaired if the goods fail to be of an acceptable quality, but the failure is not the equivalent of what is regarded as a major failure.
                            </span>
                            <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3">
                                We strongly recommend that you retain a copy of the purchase confirmation/invoice sent to your email, as we may require you to present proof that you purchased the product from us. In the case of any issues, our customer service team will be able to advise whether a refund, exchange, repair or replacement is available.
                            </span> */}




                            {/* <div className="grid sm:grid-cols-2 gap-x-5 gap-y-8 lg:grid-cols-4 xl:gap-x-8 mt-6">
                {FOUNDER_DEMO.map((item) => (
                  <div key={item.id} className="max-w-sm">
                    <NcImage
                      containerClassName="relative h-0 aspect-h-1 aspect-w-1 rounded-xl overflow-hidden"
                      className="absolute inset-0 object-cover"
                      src={item.avatar}
                    />
                    <h3 className="text-base font-semibold text-neutral-900 mt-4 md:text-xl dark:text-neutral-200">
                      {item.name}
                    </h3>
                    <span className="block text-sm text-neutral-500 sm:text-base dark:text-neutral-400">
                      {item.job}
                    </span>
                  </div>
                ))}
              </div> */}

                        </div>
                    </div>



                </div>


                <div className="">

                    <h2 className="text-xl font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100">
                        How Tidytraderr Benefits Cleaning Supplies Retailers
                    </h2>
                    <div className="text-left">
                        {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-6">
                                Refunds
                            </h2> */}
                        {/* <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3 font-medium">
                            Tidytraderr offers a range of benefits for cleaning supplies retailers:</span> */}

                        <span className="prose prose-sm  w-full dark:prose-invert space-y-1 text-sm mt-4 items-center w-full justify-start text-left lg:justify-start lg:text-left">

                            <ul>
                                <li><b>Free Seller Account</b>: Start by creating a free seller account and
                                    list as many products as you want.</li>

                                <li><b>Diverse Product Categories</b>: Choose from over 100 cleaning product
                                    categories, complete with product images, for both selling and renting.</li>

                                <li><b>Secure Payment Gateway</b>: Enjoy direct pay checkouts for every sale
                                    through Tidytraderr's secure payment gateway, powered by Stripe.</li>

                                <li><b>Customized Delivery Charges</b>: Easily set up custom delivery charges
                                    based on the distance from your store to various suburbs.</li>

                                <li><b>Market Access</b>: Gain easy access to cleaning contracts in the market.</li>

                                <li><b>FREE Job Ads</b>: Ability to publish cleaning job vacancies for free.</li>

                                <li><b>Customer Reviews</b>: Collect valuable customer reviews to build trust
                                    and reputation.</li>

                                <li><b>Efficient Management</b>: Benefit from auto-generated invoices, and order
                                    notifications.</li>

                                <li><b>Web Presence</b>: If you're a startup without a website, use your
                                    Tidytraderr account URL for marketing purposes.</li>
                            </ul>

                        </span>


                    </div>
                </div>


                <div className="">

                    <h2 className="text-xl font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100">
                        How Tidytraderr Benefits Cleaning Supplies Wholesalers
                    </h2>
                    <div className="text-left">
                        {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-6">
            Refunds
        </h2> */}
                        {/* <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3 font-medium">
                            Tidytraderr offers a wide range of benefits for cleaning supplies
                            wholesalers:</span> */}

                        <span className="prose prose-sm  w-full dark:prose-invert space-y-1 text-sm mt-4 items-center w-full justify-start text-left lg:justify-start lg:text-left">

                            <ul>
                                <li><b>Free Seller Account</b>: Get started by creating a free seller account,
                                    allowing you to list an unlimited number of products.</li>

                                <li><b>Diverse Product Categories</b>: Choose from an extensive selection of
                                    over 100 cleaning product categories, each complete with product images.
                                    This includes options for both selling and renting.</li>

                                <li><b>Minimum Order Quantities</b>: Easily set up minimum order quantities for
                                    each product, ensuring efficient order processing.</li>

                                <li><b>Effortless Purchase Orders</b>: Receive purchase orders and respond with
                                    customized quotations, including tailored delivery charges, all in an
                                    instant.</li>

                                <li><b>Secure Payment Gateway</b>: Enjoy the convenience of direct pay checkouts
                                    for every sale, made possible through Tidytraderr's secure payment
                                    gateway, powered by Stripe.</li>

                                <li><b>Market Access</b>: Gain easy access to lucrative cleaning contracts
                                    within the market.</li>

                                <li><b>Customer Reviews</b>: Enhance your reputation and build trust with
                                    valuable customer reviews from satisfied buyers.</li>

                                <li><b>Efficient Management Tools</b>: Streamline your operations with
                                    auto-generated invoices, and order notifications.</li>

                                <li><b>FREE Job Ads</b>: Ability to publish cleaning job vacancies for free.</li>

                                <li><b>Web Presence</b>: If you're a startup without a website, use your
                                    Tidytraderr account URL for marketing purposes.</li>
                            </ul>

                        </span>


                    </div>
                </div>

                <div className="">

                    <h2 className="text-xl font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100">
                        How Tidytraderr Supports Cleaning Service Providers
                    </h2>
                    <div className="text-left">
                        {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-6">
Refunds
</h2> */}
                        {/* <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3 font-medium">
                            Service providers in the cleaning industry can make the most of
                            Tidytraderr:</span> */}

                        <span className="prose prose-sm  w-full dark:prose-invert space-y-1 text-sm mt-4 items-center w-full justify-start text-left lg:justify-start lg:text-left">

                            <ul>
                                <li><b>Free Service Provider Account</b>: Create an account and promote your
                                    services for free.</li>

                                <li><b>Free Service Provider Account</b>: Create an account and promote your
                                    services for free.</li>

                                <li><b>Contract Opportunities</b>: Access open commercial, industrial, and
                                    residential cleaning contracts and submit quotations quickly.</li>

                                <li><b> Requests</b>: Receive quotation requests directly from service
                                    seekers, enhancing your sales opportunities.</li>

                                <li><b>Streamlined Operations</b>: Enjoy auto-generated invoices, order
                                    notifications, and the ability to collect customer reviews.</li>

                                <li><b>FREE Job Ads</b>: Ability to publish cleaning job vacancies for free.</li>

                                <li><b>Web Presence</b>: If you're a startup without a website, use your
                                    Tidytraderr account URL for marketing purposes.</li>


                            </ul>

                        </span>


                    </div>
                </div>


                <div className="">

                    <h2 className="text-xl font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100">
                        How Tidytraderr Benefits Service Seekers
                    </h2>
                    <div className="text-left">
                        {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-6">
Refunds
</h2> */}
                        {/* <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3 font-medium">
                            Tidytraderr simplifies the process of finding the right service provider
                            or cleaning products for service seekers:</span> */}

                        <span className="prose prose-sm  w-full dark:prose-invert space-y-1 text-sm mt-4 items-center w-full justify-start text-left lg:justify-start lg:text-left">

                            <ul>
                                <li><b>Verified Service Providers</b>: Access a database of thousands of
                                    cleaning service providers, 99.9% of whom are automatically verified
                                    before registration.</li>

                                <li><b>Effortless Sourcing</b>: Post your requirements and receive quotations
                                    from cleaning service providers. Choose the best one that suits your
                                    needs.</li>

                                <li><b>Smart Filtering</b>: Use easy filtering options to discover the nearest
                                    or most suitable cleaning service provider to get the job done.</li>

                                <li><b>Extensive Product Catalog</b>: Browse thousands of cleaning products,
                                    place orders, and have them delivered to your doorstep.</li>



                            </ul>

                        </span>


                    </div>
                </div>

                <div className="">

                    <h2 className="text-xl font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100">
                        How Tidytraderr Assists Cleaning Job Seekers
                    </h2>
                    <div className="text-left">
                        {/* <h2 className="text-base font-semibold text-neutral-900 md:text-2xl xl:text-2xl dark:text-neutral-100 mt-6">
Refunds
</h2> */}
                        {/* <span className="block text-base xl:text-base text-neutral-6000 dark:text-neutral-400 mt-3 font-medium">
                            For those seeking cleaning jobs, Tidytraderr offers an efficient job
                            search platform:</span> */}

                        <span className="prose prose-sm  w-full dark:prose-invert space-y-1 text-sm mt-4 items-center w-full justify-start text-left lg:justify-start lg:text-left">

                            <ul>
                                <li><b>Advanced Filtering</b>: Use advanced filtering options to find the most
                                    suitable cleaning job openings in your vicinity.</li>

                                <li><b>One-Click Application</b>: Utilize the "Easy Apply" option on Tidytraderr
                                    to submit your resume for jobs quickly.</li>

                                <li><b>Verified Opportunities</b>: Rest assured knowing that 99.9% of businesses
                                    on Tidytraderr are verified automatically during registration.</li>





                            </ul>

                        </span>


                    </div>
                </div>




                {/* <SectionFounder /> */}
                {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay />
        </div>

        <SectionStatistic /> */}

                {/* <SectionPromo3 /> */}
            </div>
        </div>
    );
};

export default PageAbout;
